import { ButtonV2 } from '@cimplico/components';
import { PlusCircleIcon } from '@heroicons/react/20/solid';
import { useSearchParams } from 'react-router-dom';
import EmptyStateNew from '../../../components/empty-state/EmptyStateNew';
import { Worksheet } from '../../../types/worksheet';

import Calculation from './Calculation';
import CalculationCard from './CalculationCard';

type CalculationsProps = {
    worksheet: Worksheet;
    onNewCalcClick: () => void;
};

function Calculations({ worksheet, onNewCalcClick }: CalculationsProps): JSX.Element {
    const [search, setSearch] = useSearchParams();
    const calculationId = search.get('calculationId');

    if (calculationId) {
        const calculation = worksheet.calculations.find((c) => c.id === calculationId);
        if (calculation) {
            return <Calculation calculation={calculation} worksheet={worksheet} />;
        } else {
            search.delete('calculationId');
            setSearch(search);
        }
    }

    return (
        <div className="mb-10">
            <div className="flex items-center justify-between">
                <p className="text-gray-800 font-bold text-lg">Linked Calculations</p>
                <ButtonV2 type="secondary" size="sm" label="New calculation" leftIcon={<PlusCircleIcon />} onClick={onNewCalcClick} />
            </div>
            {worksheet.calculations.length === 0 ? (
                <div className="pt-8">
                    <EmptyStateNew
                        title="Add a calculation"
                        primaryAction="New Calculation"
                        helpText="Link a calculation to this worksheet"
                        helpLink="https://support.cimplico.com/en/articles/10345912-adding-calculations-to-a-worksheet"
                        helpLinkText="Learn more"
                        onClick={onNewCalcClick}
                        actionText="New Calculation"
                    />
                </div>
            ) : (
                <div className="grid gap-4 grid-cols-[repeat(auto-fill,300px)] mt-4">
                    {worksheet.calculations.map((calc) => (
                        <CalculationCard calculation={calc} key={calc.id} worksheetId={worksheet.id} />
                    ))}
                </div>
            )}
        </div>
    );
}

export default Calculations;
